__turbopack_context__.v({
  "arrow": "y5S2_q_arrow",
  "container": "y5S2_q_container",
  "display": "y5S2_q_display",
  "open": "y5S2_q_open",
  "option": "y5S2_q_option",
  "options": "y5S2_q_options",
  "placeholder": "y5S2_q_placeholder",
  "transition": "y5S2_q_transition",
});
